<template>
	<div class="filled-content">
		<v-toolbar app flat dark color="primary">
			<v-btn icon @click="gotoOverview()">
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>E-finder Toevoegen</v-toolbar-title>
			<v-btn icon></v-btn>
		</v-toolbar>

		<v-content class="uf-form">
			<v-container class="item-group no-border pb-1 mb-0">
				Om je E-finder toe te voegen volg je 3 eenvoudige stappen:
			</v-container>

			<v-list two-line class="ma-0 pa-0">
				<v-list-tile two-line avatar class="e-connectz_list-tile">
					<v-list-tile-avatar>
						<strong>1</strong>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title class="font-weight-medium">Stap 1 - Identificeren</v-list-tile-title>
						<v-list-tile-sub-title>Welke E-finder wil je toevoegen?</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
				<v-list-tile avatar class="e-connectz_list-tile">
					<v-list-tile-avatar>
						<strong>2</strong>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title class="font-weight-medium">Stap 2 - Abonneren</v-list-tile-title>
						<v-list-tile-sub-title>Kies je abonnement.</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
			<v-list three-line class="ma-0 pa-0 pb-2">
				<v-list-tile avatar class="e-connectz_list-tile">
					<v-list-tile-avatar>
						<strong>3</strong>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title class="font-weight-medium">Stap 3 - Koppel je E-finder</v-list-tile-title>
						<v-list-tile-sub-title>Koppel je telefoon aan je E-finder.<br/>Hiervoor gebruik je de E-finder App.</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
			<v-container class="item-group">
				<p>Zorg dat je het volgende bij de hand hebt:</p>
				<ul class="mb-4">
					<li>Je E-finder</li>
					<li>Je oplaadkabel</li>
					<li>Je WiFi naam en wachtwoord</li>
				</ul>
				<p><v-btn @click="gotoNextStep" block dark depressed large color="primary">Naar stap 1 <v-icon right dark>keyboard_arrow_right</v-icon></v-btn></p>
			</v-container>
		</v-content>
	</div>
</template>

<script>
  export default {
    data() {
      return {
        code: '',
        errorMessage: '',
		loading: false
      };
    },
    watch: {
      code(value) {
        this.$nextTick(() => {
          this.code = value.replace(/[^0-9A-Fa-f]+/gi, '').toUpperCase();
        });
      }
    },
    methods: {
      gotoNextStep() {
        this.$router.replace({name: 'devices.register'});
	  },
      gotoOverview(fallback) {
        this.$router.replace({name: 'devices.list'});
      }
    }
  };
</script>

<style lang="stylus">
	.uf-form
		position: relative
		background-color: #f2f2f2

	.item-group
		background-color: #fff
		border-top: solid 1px #ddd
		border-bottom: solid 1px #ddd

		&.no-border
			border: 0
</style>
